import axiosInstance from '../axios';
import endpoints from '../endpoints';

const categoryService = {
  // Get categories for a specific contest
  getContestCategories: async (contestId, params = {}) => {
    const { page = 1, pageSize = 100 } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    const response = await axiosInstance.get(`/categories/contest/${contestId}?${queryParams}`);
    return response.data;
  },

  // Get single category by ID
  getCategoryById: async (categoryId) => {
    const response = await axiosInstance.get(`/categories/${categoryId}`);
    return response.data;
  },

  // Create category
  createCategory: async (categoryData) => {
    const response = await axiosInstance.post('/categories', categoryData);
    return response.data;
  },

  // Update category
  updateCategory: async (categoryId, categoryData) => {
    const response = await axiosInstance.put(`/categories/${categoryId}`, categoryData);
    return response.data;
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    const response = await axiosInstance.delete(`/categories/${categoryId}`);
    return response.data;
  },

  // Get category statistics
  getCategoryStats: async (categoryId) => {
    const response = await axiosInstance.get(`/categories/${categoryId}/stats`);
    return response.data;
  }
};

export default categoryService;